// extracted by mini-css-extract-plugin
export default {"backHeader":"BackHeader_backHeader__fAMvI","icon":"BackHeader_icon__7OOav","label":"BackHeader_label__ZUUk6"};